
  import {
    RESET_CHECKOUT_FORM,
  } from "~/store/checkout/constants";

  import {
    minBy,
  } from "lodash";

  import cart from "@/mixins/cart";
  import search from "@/mixins/search";
  import property from "@/mixins/property";
  import terms from "@/mixins/terms";
  import propertyFormat from "@/mixins/propertyFormat";
  import datepicker from "@/mixins/datepicker";
  import gtag from "@/mixins/gtag";
  import guestsCombination from "@/mixins/guestsCombination";
  import PropertySkeleton from '@/components/global/skeletons/PropertySkeleton.vue';
  import CartSkeleton from '@/components/global/skeletons/CartSkeleton.vue';
  import FloatingCart from '@/components/properties/FloatingCart'

  export default {
    name: "Show",
    components: {
      PropertySkeleton,
      CartSkeleton
    },
    mixins: [
      cart,
      search,
      property,
      terms,
      datepicker,
      propertyFormat,
      FloatingCart,
      gtag,
      guestsCombination
    ],
    middleware: [
      'load-page-blocks'
    ],
    data() {
      return {
        selectedRate: {},
        selectedUnitCategory: {},
        isOpenGallery: false,
        isShowMap: true,
        cartOutOfBound: true,
        isOpenCombination: 0,
        loadingUnitCombinations: true,
        unitCombination: []
      };
    },
    head() {
      return {
        title: `${this.property?.public_name ? this.property.public_name : this.property.name} - ${this.$t('main.words.book_now')}`,
        meta: [
        { hid: 'og:title', name: 'og:title', content: `${this.property?.public_name ? this.property.public_name : this.property.name} - ${this.$t('main.words.book_now')}` },
        { hid: 'og:description', name: 'og:description', content: this.$localize(this.property.short_description) ? this.$localize(this.property.short_description).replace(/<[^>]+>/g, '') : 'Book now, best price!' },
        { hid: 'description', name: 'description', content: this.$localize(this.property.short_description) ? this.$localize(this.property.short_description).replace(/<[^>]+>/g, '') : 'Book now, best price!' },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.property.images && this.property.images.length ? this.property.images[0].sizes_full_path.high : this.property.city ? `https://source.unsplash.com/random/800%C3%97800/?${this.property.city}` : 'https://source.unsplash.com/random/800%C3%97800/?travel'  ,
        }
      ],
      }
    },
    async fetch() {
      await this.submitSearch({
        id: this.$route.params.id,
        single: true,
        combinations: true,
        redirect: 'single'
      });

      this.findCombinations();
    },
    async beforeMount() {
      await this.emptyCart();
    },
    methods: {
      async apply() {
        // PULISCE LE UNITCOMBINATIONS QUANDO LA RICERCA DEGLI OSPITI CALA E VANNO QUINDI MOSTRATE LE SINGOLE TIPOLOGIE
        this.unitCombination = []

        await this.submitSearch({
          id: this.$route.params.id,
          single: true,
          combinations: true,
          redirect: 'single'
        });

        if (!!this.combinations.length) {
          this.$buefy.notification.open({
            message: this.$t('properties.search.success'),
            type: 'is-success'
          });

          this.findCombinations();
        } else {
          this.$buefy.notification.open({
            message: this.$t('properties.search.no_results'),
            type: 'is-warning'
          });
        }
      },
      async book(combination) {
        if (combination) {
          const rate = combination.best_rate || combination;
          const guests = this.guests < rate.guests ? this.guests : rate.guests;
          await this.emptyCart();
          await this.addToCart({
            ...rate,
            quantity: 1,
            guests: guests,
            children: rate.children || 0,
            currency: this.property.currency ? this.property.currency : 'EUR',
            start_date: this.searchFilters.start_date,
            end_date: this.searchFilters.end_date,
            cleaning_fee: combination.cleaning_fee
          });
        }

        this.$session.remove('step');
        this.$session.remove('form');
        this.$session.set('items', this.cartItems);

        this.$store.dispatch(RESET_CHECKOUT_FORM);

        this.$router.push(this.bookRouteByProperty(this.property, this.toAliasesFiltered(this.$route.query, this.filters)));
      },
      async bookSelectedCombination(combination) {
        if (combination) {
          await this.emptyCart();

          for (const unitCategory of combination) {
            const selectedRoomTypeDetails = unitCategory.selectedRoomTypeDetails;
            if (selectedRoomTypeDetails) {
              let guests = this.guests < selectedRoomTypeDetails.guests ? this.guests : selectedRoomTypeDetails.guests;
              await this.addToCart({
                ...selectedRoomTypeDetails,
                quantity: unitCategory.necessaryUnits,
                guests: guests,
                children: selectedRoomTypeDetails.children || 0,
                currency: this.property.currency ? this.property.currency : 'EUR',
                start_date: this.searchFilters.start_date,
                end_date: this.searchFilters.end_date,
                cleaning_fee: unitCategory.cleaning_fee
              });
            }
          }

          this.$session.remove('step');
          this.$session.remove('form');
          this.$session.set('items', this.cartItems);

          this.$store.dispatch(RESET_CHECKOUT_FORM);

          this.$router.push(this.bookRouteByProperty(this.property, this.toAliasesFiltered(this.$route.query, this.filters)));
        }
      },
      getGoogleMapsLink(latitude, longitude) {
        return `https://www.google.com/maps?q=${latitude},${longitude}`;
      },
      removeCoupon() {
        this.filters.coupon = null;
        this.apply()
      },
      getCartPosition() {
        if (!this.$refs.cartcontainer) {
          return;
        }

        let cartbounds = this.$refs.cartcontainer.getBoundingClientRect();
        let cartTop = cartbounds.top;
        let cartBottom = cartbounds.bottom;
        this.cartOutOfBound = (cartTop >= 0) && (cartBottom <= window.innerHeight + 60);
      },
      isShowUnitCategory(unitCategory) {
        if (!unitCategory.is_suggestion && !this.isSimpleView) {
          return true;
        }

        return !unitCategory.is_suggestion &&
          this.isSimpleView &&
          unitCategory.max_adults >= this.searchFilters.adults &&
          unitCategory.max_children >= this.searchFilters.children
      },

    },
    mounted () {
      window.addEventListener('scroll', this.$debounce(() => {
        this.getCartPosition()
      }, 100));
    },
    computed: {
      unitCategories() {
        if (!this.combinations.length) {
          return [];
        }

        return this.combinations.map((unitCategory) => {
          if (unitCategory.is_suggestion) {
            return unitCategory;
          }

          let rates = unitCategory.room_types.filter(
            (room_type) => this.guests <= (room_type.guests + (room_type.children ? room_type.children : 0))
          );

          unitCategory.best_rate = minBy(rates, r => parseFloat(r.amount));

          if (!unitCategory.best_rate) {
            return unitCategory;
          }

          unitCategory.best_rate.name = this.$localize(unitCategory.content_name, unitCategory.name);

          if (unitCategory.images.length) {
            unitCategory.best_rate.image = unitCategory.images[0].sizes_full_path.thumbnail
          }

          return unitCategory;
        });
      },
      availableUnitCategories() {
        if (!this.unitCategories) {
          return [];
        }

        return this.unitCategories.filter(e => e.availability > 0);
      },
      bestCombination() {
        let bestCombination = this.availableUnitCategories[0] || null;

        if (this.availableUnitCategories.length) {
          let bestAmount = parseFloat(this.availableUnitCategories[0].amount);

          this.availableUnitCategories.forEach(unitCategory => {
            if (unitCategory.best_rate && bestAmount > parseFloat(unitCategory.best_rate.amount)) {
              bestAmount = unitCategory.best_rate.amount;
              bestCombination = unitCategory.best_rate;
            }
          });
        }

        return bestCombination;
      },
      cartCalcTotalAmount() {
        let sum = 0;

        this.cartItems.map((item) => {
          const quantity = item.quantity || 1;
          sum += this.calculateTotalPrice(item.rates, {
            roomType: item,
            quantity: quantity,
            withRoomTypePromotions: true,
          });
        });

        return sum;
      },
      cartCalcTotalAmountOld() {
        let sum = 0;

        this.cartItems.map((item) => {
          const quantity = item.quantity || 1;
          sum += quantity * this.calculateTotalPrice(item.rates);
        });

        return sum;
      },
      cartTotalAmountOld() {
        const amount = this.cartCalcTotalAmount;
        const amountOld = this.cartCalcTotalAmountOld;

        if (amount === amountOld) {
          return false;
        }

        return this.$money(amountOld, this.property.currency);
      },
      cartTotalAmount() {
        return this.$money(this.cartCalcTotalAmount, this.property.currency);
      },
      cleaningFeeTotal() {
        let sum = 0;

        this.cartItems.map((item) => {
          const quantity = item.quantity || 1;
          sum += quantity * parseFloat(item.cleaning_fee);
        });

        return sum;
      },
      cartTotalAmountWithCleaningFees() {
        return this.cartCalcTotalAmount + this.cleaningFeeTotal
      },
      guests() {
        return this.searchFiltersFormatted.guests;
      },
      cartGuests() {
        let totalGuests = 0;

        this.cartItems.map((item) => {
          const children = item.children || 0;
          totalGuests += (item.guests + children) * item.quantity
        });

        return totalGuests;
      },
      cartUnits() {
        let totalUnits = 0;

        this.cartItems.map((item) => {
          totalUnits += item.quantity
        });

        return totalUnits;
      },
      isShowRefundableTerms() {
        return this.isActuallyRefundable(this.bestCombination.best_rate.rates[0].date, this.bestCombination.best_rate.refundable_terms) &&
          this.bestCombination.best_rate.refundable &&
          this.bestCombination.best_rate.rates &&
          this.bestCombination.best_rate.rates.length;
      },
    },
  };
